<svelte:head>

    <title>Auszahlungen • Ämtler-Bon Admin</title>

</svelte:head>

<script>

    import SessionManager from "../components/utils/session.svelte";
    import Payout from "../components/screens/Payout.svelte";

</script>

<SessionManager />

<section>

    <Payout />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        height: inherit;
        margin-left: 31vh;
    }

</style>
